import backend from "../../utils/backend";
import {
  GET_AUTHOR,
  GET_AUTHOR_SUCCESS,
  GET_AUTHOR_ERROR,
  GET_STORIES_STREAM,
  GET_STORIES_STREAM_SUCCESS,
  GET_STORIES_STREAM_UPDATE,
  GET_STORIES_STREAM_ERROR,
} from "../../constants/actionTypes";

export const getAuthor = (username) => {
  return (dispatch) => {
    dispatch({
      type: GET_AUTHOR,
    });

    return backend.request({
      method: "GET",
      url: `/author/${username}/`,
    })
      .then((response) => {
        dispatch({
          type: GET_AUTHOR_SUCCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_AUTHOR_ERROR,
          payload: err,
        });
      });
  };
};

export const getAuthorStories = (username, params, appendResults=false) => {
  return (dispatch) => {
    if (!appendResults) {
      dispatch({
        type: GET_STORIES_STREAM,
      });
    }

    return backend.request({
      method: "GET",
      url: `/author/${username}/stories/`,
      params,
    })
      .then((response) => {
        dispatch({
          type: appendResults ? GET_STORIES_STREAM_UPDATE : GET_STORIES_STREAM_SUCCESS,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_STORIES_STREAM_ERROR,
          payload: {
            handleError: true,
            error: err,
          },
        });
      });
  };
};
